const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white mt-12">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <p className="text-center text-sm text-gray-400">
          © 2026 Smoky Hill Engineering LLC | 9350 E Arapahoe Rd, Suite
          200,Greenwood Village, Colorado | QA/QC Excellence in Aviation & Data
          Center Infrastructure
        </p>
      </div>
    </footer>
  );
};

export default Footer;
